import { Navigate } from "react-router-dom";
import { useAuth } from "../context/Auth";
import { tokenVigente } from "./tokenVigente";

//Login del backoffice: con sesión de backoffice se va directamente a /backofficeHome
//(antes se usaba el mismo guardia para el login y para la página de inicio: con sesión, /backofficeHome
//se redirigía a sí misma en bucle y, sin sesión, se mostraba)
export const BackofficeLoginRoute = ({ children }) => {

    const { backofficeToken } = useAuth();

    if (tokenVigente(backofficeToken)) {
        return <Navigate to="/backofficeHome" />;
    }
    return children;

}

//Páginas del backoffice: hace falta sesión de backoffice
export const BackofficeRoute = ({ children }) => {

    const { backofficeToken } = useAuth();

    if (!tokenVigente(backofficeToken)) {
        return <Navigate to="/backofficeLogin" />;
    }
    return children;

}
